/* @flow */

/**
 * ScrollToTop
 *
 * React Router plugin that ensures all page transitions scroll to the top of the window
 */

import * as React from 'react';
import { withRouter } from 'react-router-dom';

type Props = {
  children: any,
  location: Object
};

function ScrollToTop({ children, location }: Props) {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return children;
}

export default withRouter(ScrollToTop);
